// DynamoPayments brand configuration — the Svelte port of src/brands/dynamopayments/config.jsx.
//
// Exactly one brand's config is bundled: vite.config.js aliases `$brand` to this file (or to
// bitcashier/config.js) based on REACT_APP_BRAND at build time, and src/brands/index.js
// re-exports it. Importing the brand's stylesheet here keeps the brand folder self-contained,
// so the alias is the only build-time switch needed.
import "./brand.css";

// Imported (not hard-coded paths) so Vite fingerprints and emits them into static/.
import logo from "./assets/logo.png";
// `?inline` forces a base64 data URI regardless of the asset size limit — the PDF renderer
// embeds the image rather than fetching a URL, so it needs the bytes, not a link.
import logoInline from "./assets/logo.png?inline";
import favicon from "./assets/favicon.png";

const brand = {
  // Document title, and the name printed on PDFs / the sign-up card.
  title: "DynamoPayments",
  images: {
    // Header + registration-page logo.
    logo,
    // Alternate logo. This brand ships a single mark, so it doubles as logo2 — that keeps the
    // config shape identical across brands (see brands/config.test.js) and matches what the
    // React config did by pointing operationConfirmation.logo at the same file.
    logo2: logo,
  },
  // Fingerprinted favicon URL. (React kept a bare filename here — "favicon-dynamo.png" served
  // from public/favicons/; the asset now lives with the brand so only the active one ships.)
  favicon,
  texts: {
    // Brand name as rendered in the app header.
    header: "DynamoPayments",
  },
  // Operation-confirmation PDFs (deposit / withdrawal / trade / ledger).
  operationConfirmation: {
    // Logo URL — for on-screen previews.
    logo,
    // Same logo as a data URI — what the PDF generator actually embeds.
    logoDataUri: logoInline,
    styles: {
      // Heading / accent-bar colour inside the PDF.
      primary: "#50BED0",
      // Tinted background fill for PDF table headers and callouts.
      secondary: "#DDF2F5",
    },
  },
  // Shown in the footer and in the PDF header block.
  contact: {
    websiteUrl: "www.dynamopayments.io",
    email: "info@dynamopayments.io",
    // No dedicated DynamoPayments support mailbox is documented anywhere in this repo, so this
    // deliberately reuses the brand's general contact address rather than inventing a `support@`
    // one that may not be monitored. Point it at the real support mailbox once it is known.
    supportEmail: "info@dynamopayments.io",
  },
  // Per-brand feature flags. Plain booleans (React paired each with a component element);
  // Svelte branches on the boolean and renders the component inline.
  components: {
    // Bank (fiat) deposit instructions panel — this brand is crypto-only.
    bankDeposits: false,
    // "Terms have changed" acceptance modal — not used by this brand.
    newTermsModal: false,
  },
};

export default brand;
